<div class="item" (click)="openBookingDash(booking)">
    <div class="itemBox">

        <div class="posterHolder">
            <div class="poster">
                <img [src]="booking.movie?.Poster" alt="">
            </div>
        </div>

        <div class="infoHolder">

            <div class="name">
                {{booking.movie?.Title }}
            </div>

            <div class="label">
                Dx:
            </div>
            <div class="address">
                {{booking.Dx}}
            </div>

            <div class="split">
                <div class="left">
                    <div class="label">
                        start date
                    </div>
                    <div class="address" *ngIf="booking && booking.startDate">
                        {{booking.startDate.toDate() | momentFormat:"MM/DD/YY"}}
                    </div>
                </div>
                <div class="righ">
                    <div class="label">
                        end date
                    </div>
                    <div class="address" *ngIf="booking && booking.endDate">
                        {{booking.endDate.toDate()| momentFormat:"MM/DD/YY"}}
                    </div>
                </div>
            </div>


            <div class="label">
                format
            </div>
            <div class="address">
                {{booking.format}}
            </div>

            <div class="split">
                <div class="left">
                    <div class="label">
                        city
                    </div>
                    <div class="address">
                        {{booking.city}}
                    </div>
                </div>
                <div class="righ">
                    <div class="label">
                        state
                    </div>
                    <div class="address">
                        {{booking.state}}
                    </div>
                </div>
            </div>

            <div class="label">
                booked by
            </div>
            <div class="person">
                {{booking.userName}}
            </div>
            
            <div class="label" *ngIf="booking.salesRep && booking.salesRep != '' ">
                SALES REP
            </div>
            <div class="person" *ngIf="booking.salesRep && booking.salesRep != '' ">
                {{booking.salesRep}}
            </div>
        </div>
    </div>

    <!-- <div class="buttons">
                            <div class="button">
                                <div class="label">Approve</div>
                            </div>
                            <div class="button">
                                <div class="label">Deny</div>
                            </div>
                        </div> -->
</div>